/** Scroll the actual app viewport, keeping the destination below its fixed header. */
export function focusUserFormSection(target, {
  documentRoot = typeof document === 'undefined' ? null : document,
  windowRoot = typeof window === 'undefined' ? null : window,
  focusTarget = target,
} = {}) {
  if (!target || !windowRoot || target.isConnected === false) return false;
  // Moving focus off a field also dismisses the mobile keyboard on a section change.
  focusTarget?.focus?.({ preventScroll: true });
  const header = documentRoot?.querySelector('.user-app-chrome__topbar');
  const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
  const bounds = target.getBoundingClientRect();
  let container = target.parentElement;
  while (container && container !== documentRoot?.body && container !== documentRoot?.documentElement) {
    if (/^(auto|scroll|overlay)$/.test(windowRoot.getComputedStyle(container).overflowY)) {
      const top = container.scrollTop + bounds.top - Math.max(container.getBoundingClientRect().top, headerBottom) - 16;
      container.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
      return true;
    }
    container = container.parentElement;
  }
  windowRoot.scrollTo({ top: Math.max(0, (windowRoot.pageYOffset || 0) + bounds.top - headerBottom - 16), behavior: 'auto' });
  return true;
}

/** Resolve a validation entry to its section and input without exposing form values. */
export function findUserFormField(root, fieldId) {
  const marker = [...(root?.querySelectorAll('[data-field]') || [])].find(node => node.getAttribute('data-field') === fieldId);
  const section = marker?.closest('.qi-block');
  if (!section) return null;
  const sectionIndex = [...root.querySelectorAll('.qi-form > .qi-block')].indexOf(section);
  const target = marker.closest('label, .checkbox-group, .photo-card') || marker.parentElement;
  const control = target?.querySelector('input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])');
  return sectionIndex < 0 ? null : { sectionIndex, target, control };
}
